import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateFiscalComponent } from './create-fiscal.component';
import { Step1CompanyComponent } from './step1-company/step1-company.component';
import { Step2FiscalComponent } from './step2-fiscal/step2-fiscal.component';
import { Step3VerifyComponent } from './step3-verify/step3-verify.component';
import { AcceptTermsComponent } from './step3-verify/accept-terms/accept-terms.component';
import { FiscalPreviewComponent } from './step3-verify/fiscal-preview/fiscal-preview.component';

  @NgModule({
  declarations: [CreateFiscalComponent, Step1CompanyComponent, Step2FiscalComponent, Step3VerifyComponent, AcceptTermsComponent, FiscalPreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [ ],
  exports: [CreateFiscalComponent]
})
export class CreateFiscalModule {
  customElementComponent: Type<any> = CreateFiscalComponent;
}

